import { toast } from 'react-toastify';
import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import { Handlers } from '../../../types/actions/types';
import { fetchRelatedPartyBankTransactionsService, fetchRelatedPartyDataService } from './relatedParties_service';
import { toRptBankTransactions } from './relatedPartyTransactions_mappers';
import type { BankTransaction } from '../../../modules/Dashboard/DashboardModules/Financials/components/FinancialsFromBankingV2/types';

export async function fetchRelatedPartiesData(payload, options?: { withRequestedOrg?: boolean }) {
    try {
        const response = await fetchRelatedPartyDataService(payload, options);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return response?.data?.responseBody;
            case JAVA_API_STATUS.ERROR:
                return null;
        }
    } catch (err) {
        return null;
    }
}

export async function fetchRelatedPartyBankTransactions(orgId: string, partyKey: string): Promise<BankTransaction[]> {
    try {
        return toRptBankTransactions(await fetchRelatedPartyBankTransactionsService(orgId, partyKey)) ?? [];
    } catch {
        return [];
    }
}
